import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import useDocDownload from "../../hooks/useDocDownload";
import { useDispatch, useSelector } from "react-redux";
import { deleteBackgroundChecks, deleteBcDoc, getBackgroundChecks, getBcDeleteStatus, getBcDocDeleteStatus, loadBackgroundChecks } from "../../store/candidate";
import AddBcChecks from "../../../components/OMCRegistry/AddBcChecks";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";

const BcChecks = (props) => {

    const { subProccessTask, candidateObj, onOpenAddBcCheck } = props;
    const [backgroundChecks, setBackgroundChecks] = useState([]);
    const backgroundChecksSelector = useSelector(getBackgroundChecks);
    const bcDeleteStatusSelector = useSelector(getBcDeleteStatus);
    const bcDocDeleteStatusSelector = useSelector(getBcDocDeleteStatus);

    const [handleDownloadFile] = useDocDownload();

    const dispatch = useDispatch();

    useEffect(() => {
        if (subProccessTask?.applicantId > 0) {
            dispatch(loadBackgroundChecks(subProccessTask.applicantId));
        }
    }, [subProccessTask]);

    useEffect(() => {
        setBackgroundChecks(backgroundChecksSelector);
    }, [backgroundChecksSelector])

    const handleBcCheckShowHide = (obj, type) => {
        if (onOpenAddBcCheck) {
            onOpenAddBcCheck(obj, type);
        }
    }

    const handleDeleteTimeSheetDoc = async (id) => {
        const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
        if (result.isConfirmed) {
            dispatch(deleteBcDoc(id));
        }
    }

    const handleDeleteBcDoc = () => {

    }

    const handleDeleteBcChecks = async (id) => {
        const result = await getConfirmAlert("", "Are you sure you want to Delete this Background Check?", "warning");
        if (result.isConfirmed) {
            dispatch(deleteBackgroundChecks(id))
        }
    }

    useEffect(() => {
        if (bcDeleteStatusSelector || bcDocDeleteStatusSelector) {
            getAlert("", "Deleted Successfully", "success");

            if (subProccessTask?.applicantId > 0)
                dispatch(loadBackgroundChecks(subProccessTask.applicantId));
        }
    }, [bcDeleteStatusSelector, bcDocDeleteStatusSelector])



    const handleBcLoad = () => {
        if (subProccessTask?.applicantId > 0)
            dispatch(loadBackgroundChecks(subProccessTask.applicantId));
    }

    const totalChecks = backgroundChecks.length;
    const passedChecks = backgroundChecks.filter(item => item.status === true).length;
    const failedChecks = backgroundChecks.filter(item => item.status === false && item.status !== null).length;
    const pendingChecks = backgroundChecks.filter(item => item.status === null).length;

    return (
        <div className="bc-container col-md-12">
            <style>{`
                .bc-container {
                    margin-top: 10px;
                }
                
                /* ── Animations (Matched with ManageWorkflowPerformer) ── */
                @keyframes rowFadeIn {
                  from { opacity: 0; transform: translateY(4px); }
                  to   { opacity: 1; transform: translateY(0); }
                }
                @keyframes tabFadeIn {
                  from { opacity: 0; transform: translateY(6px); }
                  to   { opacity: 1; transform: translateY(0); }
                }

                /* ── Stats widgets ── */
                .bc-stats-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 16px;
                    margin-bottom: 20px;
                }
                @media (max-width: 992px) {
                    .bc-stats-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }
                @media (max-width: 576px) {
                    .bc-stats-grid {
                        grid-template-columns: 1fr;
                    }
                }
                .bc-stat-card {
                    background: rgba(255, 255, 255, 0.97);
                    border: 1px solid rgba(226, 232, 240, 0.8);
                    border-radius: 14px;
                    padding: 16px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.04);
                    transition: all 0.25s ease;
                }
                .bc-stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.08);
                    border-color: rgba(37, 99, 235, 0.2);
                }
                .bc-stat-icon {
                    width: 44px;
                    height: 44px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                    flex-shrink: 0;
                    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.03);
                }
                .bc-stat-icon.total { background: #f8fafc; color: #64748b; border: 1px solid #e2e8f0; }
                .bc-stat-icon.passed { background: rgba(16,185,129,0.08); color: #047857; border: 1px solid rgba(16,185,129,0.15); }
                .bc-stat-icon.failed { background: rgba(239,68,68,0.08); color: #b91c1c; border: 1px solid rgba(239,68,68,0.15); }
                .bc-stat-icon.pending { background: rgba(245,158,11,0.08); color: #b45309; border: 1px solid rgba(245,158,11,0.15); }
                
                .bc-stat-content {
                    min-width: 0;
                }
                .bc-stat-value {
                    font-size: 22px;
                    font-weight: 800;
                    color: #0f172a;
                    line-height: 1.1;
                }
                .bc-stat-label {
                    font-size: 11px;
                    font-weight: 750;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    margin-top: 2px;
                }
                
                /* ── Toolbar ── */
                .bc-toolbar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 12px;
                    margin-bottom: 22px;
                    padding: 12px 18px;
                    background: #ffffff;
                    border: 1px solid rgba(226, 232, 240, 0.8);
                    border-radius: 14px;
                    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.03);
                }
                .bc-toolbar-group {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
                
                /* ── Buttons (Matched with ManageWorkflowPerformer) ── */
                .btn-search-trigger {
                  display: inline-flex !important; align-items: center !important; justify-content: center !important;
                  gap: 8px !important; background: #ffffff !important; border: 1px solid #e2e8f0 !important;
                  padding: 7px 14px !important; border-radius: 8px !important; font-size: 12.5px !important;
                  font-weight: 600 !important; color: #475569 !important; cursor: pointer !important;
                  transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
                  box-shadow: 0 1px 2px 0 rgba(0,0,0,0.02) !important;
                }
                .btn-search-trigger:hover {
                  background: #f8fafc !important; color: #0f172a !important;
                  border-color: #cbd5e1 !important; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
                }
                .btn-search-trigger i {
                    transition: transform 0.4s ease;
                }
                .btn-search-trigger:hover i.fa-refresh {
                    transform: rotate(180deg);
                }
                .btn-action-search {
                  display: inline-flex !important; align-items: center !important; gap: 8px !important;
                  background: #ffffff !important; border: 1px solid #cbd5e1 !important;
                  padding: 7px 14px !important; border-radius: 8px !important; font-size: 13px !important;
                  font-weight: 600 !important; color: #475569 !important; cursor: pointer !important;
                  transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important; outline: none !important;
                }
                .btn-action-search:hover {
                  background: #f8fafc !important; color: #0f172a !important;
                  border-color: #94a3b8 !important; transform: translateY(-1px) !important;
                  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
                }
                .btn-action-search.btn-primary-search {
                  background: #2563eb !important; color: #ffffff !important; border-color: #2563eb !important;
                  box-shadow: 0 4px 10px -1px rgba(37,99,235,0.18) !important;
                }
                .btn-action-search.btn-primary-search:hover {
                  background: #1d4ed8 !important; transform: translateY(-1px) !important;
                  box-shadow: 0 4px 12px -1px rgba(37,99,235,0.28) !important;
                }
                .btn-action-search.btn-danger-search {
                  background: rgba(239,68,68,0.06) !important; color: #dc2626 !important;
                  border: 1px solid rgba(239,68,68,0.18) !important;
                }
                .btn-action-search.btn-danger-search:hover {
                  background: rgba(239,68,68,0.12) !important; color: #b91c1c !important;
                  border-color: rgba(239,68,68,0.28) !important; transform: translateY(-1px) !important;
                  box-shadow: 0 4px 8px -2px rgba(239,68,68,0.12) !important;
                }

                /* ── Table (Matched with ManageWorkflowPerformer) ── */
                .wf-table-scroll {
                  overflow: auto !important; scrollbar-width: thin; scrollbar-color: #94a3b8 #f1f5f9;
                  border-radius: 14px; border: 1px solid rgba(226, 232, 240, 0.8);
                  box-shadow: 0 4px 16px -4px rgba(15, 23, 42, 0.04);
                  background: #ffffff; margin-bottom: 24px;
                }
                .wf-table-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
                .wf-table-scroll::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 999px; }
                .wf-table-scroll::-webkit-scrollbar-thumb {
                  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
                  border-radius: 999px; border: 2px solid #f1f5f9;
                }
                .wf-table {
                  width: 100% !important;
                  border-collapse: separate !important;
                  border-spacing: 0 2px !important;
                  margin-bottom: 0 !important;
                }
                .wf-thead {
                  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
                  position: sticky !important; top: 0 !important; z-index: 2 !important;
                }
                .wf-thead th {
                  font-size: 11.5px !important; font-weight: 700 !important; color: #475569 !important;
                  text-transform: uppercase !important; letter-spacing: 0.6px !important;
                  padding: 13px 16px !important; border-bottom: 2px solid #e2e8f0 !important;
                  border-top: none !important; white-space: nowrap !important;
                }
                .wf-table-row {
                  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
                  animation: rowFadeIn 0.25s ease both !important;
                }
                .wf-table-row:hover {
                  background: linear-gradient(90deg, rgba(37,99,235,0.03) 0%, rgba(37,99,235,0.01) 100%) !important;
                  box-shadow: inset 3px 0 0 0 rgba(37,99,235,0.3) !important;
                }
                .wf-table td {
                  padding: 13px 16px !important; font-size: 13.5px !important; color: #334155 !important;
                  border-bottom: 1px solid #f1f5f9 !important; vertical-align: top !important;
                }
                .wf-table tbody tr:last-child td { border-bottom: none !important; }
                
                /* Column layouts */
                .bc-col-seq { width: 60px; text-align: center; }
                .bc-col-info { min-width: 180px; }
                .bc-col-records { min-width: 260px; }
                .bc-col-candidate { min-width: 260px; }
                .bc-col-status { width: 140px; white-space: nowrap !important; }
                .bc-col-actions { width: 110px; text-align: right; }
                
                .wf-id-cell {
                  display: inline-flex; align-items: center; justify-content: center;
                  min-width: 32px; padding: 4px 8px; border-radius: 999px;
                  background: #f8fafc; border: 1px solid #e2e8f0;
                  font-size: 12px; font-weight: 700; color: #64748b;
                }
                
                .bc-card-title {
                    font-size: 14.5px;
                    font-weight: 700;
                    color: #1e293b;
                    margin: 0 0 6px 0;
                }
                .bc-card-time {
                    font-size: 12px;
                    color: #64748b;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }
                .bc-card-time i { color: #94a3b8; }
                
                .bc-section-label {
                    font-size: 10px;
                    font-weight: 800;
                    color: #94a3b8;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    margin-bottom: 6px;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }
                
                .bc-notes-area {
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    padding: 10px 12px;
                    font-size: 13px;
                    line-height: 1.4;
                    color: #334155;
                    position: relative;
                    margin-bottom: 8px;
                }
                .bc-notes-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 4px;
                }
                .bc-notes-title {
                    font-size: 10px;
                    font-weight: 750;
                    color: #94a3b8;
                    text-transform: uppercase;
                }
                .btn-action-search.btn-edit-search {
                  background: rgba(37,99,235,0.06) !important; color: #2563eb !important;
                  border: 1px solid rgba(37,99,235,0.18) !important;
                }
                .btn-action-search.btn-edit-search:hover {
                  background: rgba(37,99,235,0.12) !important; color: #1d4ed8 !important;
                  border-color: rgba(37,99,235,0.28) !important; transform: translateY(-1px) !important;
                  box-shadow: 0 4px 8px -2px rgba(37,99,235,0.12) !important;
                }
                .bc-notes-content {
                    white-space: pre-wrap;
                }
                .bc-notes-empty {
                    color: #94a3b8;
                    font-style: italic;
                }
                
                .bc-docs-list {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                }
                .bc-doc-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 6px;
                    padding: 6px 10px;
                    transition: border-color 0.2s ease;
                }
                .bc-doc-item:hover {
                    border-color: #cbd5e1;
                }
                .bc-doc-link-btn {
                    background: transparent;
                    border: none;
                    color: #2563eb;
                    font-size: 12.5px;
                    font-weight: 650;
                    text-align: left;
                    padding: 0;
                    cursor: pointer;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    min-width: 0;
                }
                .bc-doc-link-btn:hover {
                    color: #1d4ed8;
                    text-decoration: underline;
                }
                .bc-doc-link-btn span {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .bc-doc-link-btn i {
                    color: #94a3b8;
                    font-size: 13px;
                    flex-shrink: 0;
                }
                .bc-doc-delete-btn {
                    background: transparent;
                    border: none;
                    color: #ef4444;
                    padding: 2px;
                    border-radius: 4px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                }
                .bc-doc-delete-btn:hover {
                    background: #fef2f2;
                    color: #b91c1c;
                }
                
                /* ── Badges (Matched with ManageWorkflowPerformer) ── */
                .badge-capsule {
                  display: inline-flex !important; align-items: center !important; justify-content: center !important;
                  padding: 4px 10px !important; border-radius: 20px !important;
                  font-size: 12px !important; font-weight: 600 !important; line-height: 1 !important;
                  gap: 5px !important;
                }
                .badge-capsule-dot {
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    display: inline-block;
                }
                .badge-system { background: #f1f5f9 !important; color: #475569 !important; border: 1px solid #cbd5e1 !important; }
                .badge-system .badge-capsule-dot { background: #64748b; }
                .badge-azure { background: rgba(37,99,235,0.08) !important; color: #1d4ed8 !important; border: 1px solid rgba(37,99,235,0.15) !important; }
                .badge-azure .badge-capsule-dot { background: #2563eb; }
                .badge-active { background: rgba(16,185,129,0.08) !important; color: #047857 !important; border: 1px solid rgba(16,185,129,0.15) !important; }
                .badge-active .badge-capsule-dot { background: #10b981; }
                .badge-inactive { background: rgba(239,68,68,0.08) !important; color: #b91c1c !important; border: 1px solid rgba(239,68,68,0.15) !important; }
                .badge-inactive .badge-capsule-dot { background: #ef4444; }

                .bc-notify-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    padding: 10px 12px;
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }
                .bc-notify-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 2px;
                }
                .btn-action-search.btn-success-search {
                  background: rgba(16,185,129,0.06) !important; color: #047857 !important;
                  border: 1px solid rgba(16,185,129,0.18) !important;
                }
                .btn-action-search.btn-success-search:hover {
                  background: rgba(16,185,129,0.12) !important; color: #065f46 !important;
                  border-color: rgba(16,185,129,0.28) !important; transform: translateY(-1px) !important;
                  box-shadow: 0 4px 8px -2px rgba(16,185,129,0.12) !important;
                }
                
                .bc-status-time-box {
                    font-size: 12px;
                    color: #64748b;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 6px;
                    white-space: nowrap !important;
                }
                .bc-status-time-box i { color: #94a3b8; }

                /* ── Empty State (Matched with ManageWorkflowPerformer) ── */
                .wf-empty-state {
                  display: flex; flex-direction: column; align-items: center; justify-content: center;
                  padding: 40px 24px; text-align: center; gap: 12px;
                  animation: tabFadeIn 0.3s ease both;
                }
                .wf-empty-icon {
                  width: 52px; height: 52px; border-radius: 14px;
                  display: flex; align-items: center; justify-content: center; font-size: 22px;
                  background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(124,58,237,0.06) 100%);
                  border: 1px solid rgba(37,99,235,0.12); color: #2563eb; margin-bottom: 4px;
                }
                .wf-empty-title { font-size: 15px; font-weight: 700; color: #1e293b; margin: 0; }
                .wf-empty-desc { font-size: 13px; color: #64748b; margin: 0 auto; line-height: 1.6; }
            `}</style>

            {/* Overview Stats widgets */}
            <div className="bc-stats-grid">
                <div className="bc-stat-card">
                    <div className="bc-stat-icon total">
                        <i className="fa fa-list-alt" aria-hidden="true" />
                    </div>
                    <div className="bc-stat-content">
                        <div className="bc-stat-value">{totalChecks}</div>
                        <div className="bc-stat-label">Total Checks</div>
                    </div>
                </div>
                <div className="bc-stat-card">
                    <div className="bc-stat-icon passed">
                        <i className="fa fa-check-circle" aria-hidden="true" />
                    </div>
                    <div className="bc-stat-content">
                        <div className="bc-stat-value">{passedChecks}</div>
                        <div className="bc-stat-label">Passed</div>
                    </div>
                </div>
                <div className="bc-stat-card">
                    <div className="bc-stat-icon failed">
                        <i className="fa fa-times-circle" aria-hidden="true" />
                    </div>
                    <div className="bc-stat-content">
                        <div className="bc-stat-value">{failedChecks}</div>
                        <div className="bc-stat-label">Failed</div>
                    </div>
                </div>
                <div className="bc-stat-card">
                    <div className="bc-stat-icon pending">
                        <i className="fa fa-clock-o" aria-hidden="true" />
                    </div>
                    <div className="bc-stat-content">
                        <div className="bc-stat-value">{pendingChecks}</div>
                        <div className="bc-stat-label">Pending</div>
                    </div>
                </div>
            </div>

            {/* Toolbar section */}
            <div className="bc-toolbar">
                <div className="bc-toolbar-group">
                    <a
                        href="https://ows01.hireright.com/login/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-search-trigger"
                    >
                        <i className="fa fa-external-link" aria-hidden="true" />
                        Link To Hire Right
                    </a>
                </div>
                <div className="bc-toolbar-group">
                    <button
                        type="button"
                        className="btn-action-search btn-primary-search"
                        onClick={() => handleBcCheckShowHide(null, "new")}
                    >
                        <i className="fa fa-plus" aria-hidden="true" />
                        Add New Check
                    </button>
                    <button
                        type="button"
                        className="btn-search-trigger"
                        onClick={handleBcLoad}
                    >
                        <i className="fa fa-refresh" aria-hidden="true" />
                        Refresh
                    </button>
                </div>

            </div>

            {/* Background Check Premium Table */}
            <div className="wf-table-scroll">
                <table className="wf-table">
                    <thead className="wf-thead">
                        <tr>
                            <th className="bc-col-seq">#</th>
                            <th className="bc-col-info">Check Name & Date</th>
                            <th className="bc-col-records">Internal Records</th>
                            <th className="bc-col-candidate">Candidate Notification</th>
                            <th className="bc-col-status">Status</th>
                            <th className="bc-col-actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {backgroundChecks.length > 0 ? (
                            backgroundChecks.map((item, key) => {
                                // Calculate status info
                                let statusBadge = (
                                    <span className="badge-capsule badge-system">
                                        <span className="badge-capsule-dot" />
                                        Pending
                                    </span>
                                );
                                if (item.status === true) {
                                    statusBadge = (
                                        <span className="badge-capsule badge-active">
                                            <span className="badge-capsule-dot" />
                                            Passed
                                        </span>
                                    );
                                } else if (item.status === false && item.status !== null) {
                                    statusBadge = (
                                        <span className="badge-capsule badge-inactive">
                                            <span className="badge-capsule-dot" />
                                            Failed
                                        </span>
                                    );
                                }

                                return (
                                    <tr key={item.id || key} className="wf-table-row">
                                        <td className="bc-col-seq">
                                            <span className="wf-id-cell">{key + 1}</span>
                                        </td>
                                        <td className="bc-col-info">
                                            <h4 className="bc-card-title">{item.name}</h4>
                                            <div className="bc-card-time">
                                                <i className="fa fa-calendar-o" aria-hidden="true" />
                                                <Moment format="MMM Do YYYY, h:mm a">
                                                    {item.addedDateTime}
                                                </Moment>
                                            </div>
                                        </td>
                                        <td className="bc-col-records">
                                            <div className="bc-notes-area">
                                                <div className="bc-notes-header">
                                                    <span className="bc-notes-title">Internal Notes</span>
                                                    <button
                                                        type="button"
                                                        className="btn-action-search btn-edit-search"
                                                        onClick={() => handleBcCheckShowHide(item, "edit")}
                                                    >
                                                        <i className="fa fa-pencil-square-o" aria-hidden="true" />
                                                        Edit
                                                    </button>
                                                </div>
                                                <div className="bc-notes-content">
                                                    {item.notes ? item.notes : (
                                                        <span className="bc-notes-empty">No internal notes added yet.</span>
                                                    )}
                                                </div>
                                            </div>

                                            {item.updatedDocList && item.updatedDocList.length > 0 && (
                                                <div>
                                                    <span className="bc-section-label">Documents Uploaded</span>
                                                    <ul className="bc-docs-list">
                                                        {item.updatedDocList.map((doc, docIdx) => (
                                                            <li key={doc.id || docIdx} className="bc-doc-item">
                                                                <button
                                                                    type="button"
                                                                    className="bc-doc-link-btn"
                                                                    onClick={() => handleDownloadFile(doc)}
                                                                    title="Download document"
                                                                >
                                                                    <i className="fa fa-paperclip" aria-hidden="true" />
                                                                    <span>{doc.documentName}</span>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="bc-doc-delete-btn"
                                                                    onClick={() => handleDeleteTimeSheetDoc(doc.id)}
                                                                    title="Delete document"
                                                                >
                                                                    <i className="fa fa-trash-o" aria-hidden="true" />
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </td>
                                        <td className="bc-col-candidate">
                                            <div className="bc-notify-card">
                                                <div className="bc-notify-header">
                                                    <span className="bc-notes-title">Status</span>
                                                    {item.sendStatus ? (
                                                        <span className="badge-capsule badge-active">
                                                            <i className="fa fa-check" aria-hidden="true" />
                                                            Notified
                                                        </span>
                                                    ) : (
                                                        <span className="badge-capsule badge-system">
                                                            <i className="fa fa-exclamation-circle" aria-hidden="true" />
                                                            Pending
                                                        </span>
                                                    )}
                                                </div>

                                                {item.sendStatus ? (
                                                    <div style={{ fontSize: '12.5px', color: '#475569' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                            <i className="fa fa-clock-o" style={{ color: '#94a3b8' }} />
                                                            <span>
                                                                Sent: <Moment format="MMM Do, h:mm a">{item.notifyDateTime}</Moment>
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                        <button
                                                            type="button"
                                                            className="btn-action-search btn-success-search"
                                                            onClick={() => handleBcCheckShowHide(item, "notify")}
                                                        >
                                                            <i className="fa fa-envelope-o" aria-hidden="true" />
                                                            Notify
                                                        </button>
                                                    </div>
                                                )}

                                                {item.instructionNotes && (
                                                    <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '6px', marginTop: '2px' }}>
                                                        <span className="bc-notes-title" style={{ display: 'block', marginBottom: '2px' }}>Instructions</span>
                                                        <div style={{ fontSize: '12px', color: '#475569', whiteSpace: 'pre-wrap' }}>{item.instructionNotes}</div>
                                                    </div>
                                                )}

                                                {item.docList && item.docList.length > 0 && (
                                                    <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '6px', marginTop: '2px' }}>
                                                        <span className="bc-notes-title" style={{ display: 'block', marginBottom: '4px' }}>Shared Files</span>
                                                        <ul className="bc-docs-list">
                                                            {item.docList.map((doc, docIdx) => (
                                                                <li key={doc.id || docIdx} className="bc-doc-item" style={{ background: '#f8fafc', padding: '4px 8px' }}>
                                                                    <button
                                                                        type="button"
                                                                        className="bc-doc-link-btn"
                                                                        onClick={() => handleDownloadFile(doc)}
                                                                    >
                                                                        <i className="fa fa-file-text-o" aria-hidden="true" />
                                                                        <span>{doc.documentName}</span>
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td className="bc-col-status">
                                            {statusBadge}
                                            {item.updatedDateTime && (
                                                <div className="bc-status-time-box">
                                                    <i className="fa fa-calendar-check-o" aria-hidden="true" />
                                                    <span>
                                                        <Moment format="MMM Do, h:mm a">{item.updatedDateTime}</Moment>
                                                    </span>
                                                </div>
                                            )}
                                        </td>
                                        <td className="bc-col-actions">
                                            <button
                                                type="button"
                                                className="btn-action-search btn-danger-search"
                                                onClick={() => handleDeleteBcChecks(item.id)}
                                                title="Delete Background Check"
                                            >
                                                <i className="fa fa-trash-o" aria-hidden="true" />
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={6} style={{ padding: 0 }}>
                                    <div className="wf-empty-state">
                                        <div className="wf-empty-icon">
                                            <i className="fa fa-folder-open-o" aria-hidden="true" />
                                        </div>
                                        <p className="wf-empty-title">No Background Checks Found</p>
                                        <p className="wf-empty-desc">
                                            Click "Add New Check" above to start tracking background checks.
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default BcChecks;
